import { buildElementSelector, ELEMENT_ID, TElementId } from "@app/core/constants/element-ids.const";
import { EOnboardingPlacement } from "@app/shared/types/onboarding.type";

//  Builds the `[data-element-id="…"]` selector for a registered element id.
//  Delegates to buildElementSelector so the selector format has a single source of truth.
export const sel = (id: TElementId): string => buildElementSelector(id);

//  A step target that is (or lives inside) a Material menu is detected via these selectors. 
export const MENU_TRIGGER_SELECTOR = ".mat-mdc-menu-trigger, [aria-haspopup='menu']";
export const MENU_PANEL_SELECTOR = ".cdk-overlay-container .mat-mdc-menu-panel";

// Steps whose target lives inside a menu: the spotlight follows `anchor` (the menu
//  trigger) and the tooltip uses the configured placement.
export const MENU_ANCHOR_TARGETS: Record<string, { anchor: string; placement: EOnboardingPlacement }> = {
  [sel(ELEMENT_ID.ClientDetails)]: {
    anchor: sel(ELEMENT_ID.ClientActionMenu),
    placement: EOnboardingPlacement.Left,
  },
};
